import Typing from 'react-typing-animation';

class _Typing extends Typing {
    componentWillReceiveProps({ children }) {
    }


    type = async () => {
        const toType = [...this.state.toType];
        let cursor = { ...this.state.cursor };

        while (
            toType &&
            toType[0] &&
            toType[0].type &&
            toType[0].type.updateCursor &&
            cursor.numToErase < 1
        ) {
            cursor = toType[0].type.updateCursor(cursor, toType[0].props);
            toType.shift();
        }

        await this.updateState({ cursor, toType });


        if (cursor.charPos === 0 && !this.stoped) {
            this.stoped = true
            this.props.onStopped && this.props.onStopped()
        } else if (cursor.charPos !== 0 && this.stoped) {
            this.stoped = false
            this.props.onStarted && this.props.onStarted()
        }

        return this.animateNextStep();
    };
}

export default _Typing;


// WEBPACK FOOTER //
// ./src/components/common/MTyping.js